import { trpc } from '@/services/trpc';

export function useSkillMutation() {
  const utils = trpc.useUtils();

  const invalidate = async () => utils.skills.findAll.invalidate();

  const create = trpc.skills.create.useMutation({ onSuccess: invalidate });

  const update = trpc.skills.update.useMutation({ onSuccess: invalidate });

  const remove = trpc.skills.delete.useMutation({ onSuccess: invalidate });

  return { create, update, remove };
}
